<!--时间间隔选择-->
<template>
	<span class="intervalbody">
		<span>间隔(分钟)</span>
		<span class="span-m">
			<span v-for="i in times" @click="nowSelect = i">
				<img :src="getImg(i)"/>{{i}}
			</span>
		</span>
	</span>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: ['defaultInterval'],
		data() {
			return {
				times: [5, 15, 30, 60],
				nowSelect: 5,
			}
		},
		created() {},
		mounted() {
			if(this.defaultInterval) {
				this.nowSelect = this.defaultInterval
			} else {
				this.$emit("selectInterval", this.nowSelect)
			}
		},
		destroyed() {},
		computed: {
			getImg() {
				return i => {
					if(i == this.nowSelect) {
						return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
					}
					return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
				}
			}
		},
		watch: {
			nowSelect(nv, ov) {
				this.$emit("selectInterval", nv)
			}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.span-m{
	    border: solid #d4d4d4 .01rem;
	    border-radius: .05rem;
	    line-height: 0.28rem;
	    margin: 0 5px;;
	    height: 0.28rem;
	    padding: 0 5px;;
	    display: flex;
	    align-items: center;
	    color: white;
	}
	.span-m span{
		text-align: center;
	    display: flex;
	    align-items: center;
	    margin-right: 0.05rem;
	    color: black;
	}
	.intervalbody {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: white;
	}
	.intervalbody span{
		color: black;
	}

	.intervalbody img {
		width: .13rem;
		height: .13rem;
		margin-right: .05rem;
	}
</style>
